import { inject as n, provide as t } from "vue";
const o = "v-theme-config";
function f() {
  const e = n(o);
  if (!e)
    throw "No theme config found";
  return e;
}
function r(e) {
  t(o, e);
}
export {
  r as provideThemeConfig,
  f as useThemeConfig
};
